"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _IconButton = _interopRequireDefault(require("../../Buttons/IconButton"));
var _Popover = _interopRequireDefault(require("../../Tooltips/Popover"));
var _helpers = require("../../helpers");
var _excluded = ["children", "isActive", "automationHook", "cardProps"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var NotificationButton = (0, _styledComponents["default"])(_IconButton["default"]).withConfig({
  displayName: "Notifications__NotificationButton",
  componentId: "sc-1cm9pgy-0"
})(["", ";"], function (props) {
  return props.isActive && "\n        &:after {\n          content: \"\";\n          display: block;\n          position: absolute;\n          width: 8px;\n          height: 8px;\n          left: 50%;\n          bottom:  50%;\n          border-radius: 50%;\n          background-color: ".concat(props.theme.colors.error, ";\n          border: 1px solid ").concat(props.theme.colors.backgroundPrimary, "\n        }\n        &:hover,\n        &:focus  {\n          &:after{\n            background-color:").concat((0, _helpers.darkenSafe)(0.1, props.theme.colors.error), ";\n          }\n       }\n        }\n      ");
});
var propTypes = {
  /** Function that returns component that will be rendered in popover card */
  children: _propTypes["default"].func,
  /** Wether notification is active*/
  isActive: _propTypes["default"].bool,
  /** Hook used for automation testing */
  automationHook: _propTypes["default"].string,
  /** Props to be passed to PopoverCard */
  cardProps: _propTypes["default"].object
};
var Notifications = function Notifications(_ref) {
  var children = _ref.children,
    isActive = _ref.isActive,
    automationHook = _ref.automationHook,
    _ref$cardProps = _ref.cardProps,
    cardProps = _ref$cardProps === void 0 ? {} : _ref$cardProps,
    other = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_Popover["default"], _extends({
    cardProps: _objectSpread({
      p: "base"
    }, cardProps),
    triggerW: "auto",
    align: "end",
    automationHook: automationHook,
    renderTrigger: function renderTrigger(_ref2) {
      var togglePopover = _ref2.togglePopover;
      return /*#__PURE__*/_react["default"].createElement(NotificationButton, _extends({
        onClick: togglePopover,
        isActive: isActive,
        name: "BellFill",
        shape: "round",
        color: "border",
        textColor: "text",
        variant: "border",
        w: "40px"
      }, other));
    }
  }, other), function (_ref3) {
    var closePopover = _ref3.closePopover,
      isOpen = _ref3.isOpen;
    return children({
      closePopover: closePopover,
      isOpen: isOpen
    });
  });
};
Notifications.propTypes = propTypes;
var _default = Notifications;
exports["default"] = _default;